import { useEffect, useLayoutEffect } from 'react'

import { hasAnalyticsByLocale } from 'helpers'

import {
  selectFacebookPixelIds,
  selectLanguage,
} from 'root-redux/selects/common'
import { selectUUID, selectUserCountryCode } from 'root-redux/selects/user'

import { useBulkSelector } from 'hooks/common/useBulkSelector'
import { useCookieConsentAnswer } from 'hooks/common/useCookieConsentAnswer'

import { FBConsent } from 'root-constants/common'

const useSelectors = () =>
  useBulkSelector({
    uuid: selectUUID,
    facebookPixelIds: selectFacebookPixelIds,
    userCountryCode: selectUserCountryCode,
    language: selectLanguage,
  })

export const useFacebookPixelInitialization = (): void => {
  const { uuid, facebookPixelIds, userCountryCode, language } = useSelectors()

  const { hasAdvertisingAndTargetingCookie, shouldApplyCookieConsent } =
    useCookieConsentAnswer()

  useLayoutEffect(() => {
    if (!window.fbq || !facebookPixelIds.length || !uuid || !userCountryCode) {
      return
    }

    facebookPixelIds.forEach((facebookPixelId) => {
      window.fbq('init', facebookPixelId, { external_id: uuid })
    })
    window.fbq('track', 'PageView')
  }, [facebookPixelIds, userCountryCode, uuid])

  useEffect(() => {
    if (
      !window.fbq ||
      !shouldApplyCookieConsent ||
      hasAnalyticsByLocale(language)
    ) {
      return
    }

    window.fbq(
      'consent',
      hasAdvertisingAndTargetingCookie ? FBConsent.GRANT : FBConsent.REVOKE,
    )
  }, [hasAdvertisingAndTargetingCookie, shouldApplyCookieConsent, language])
}
